module.exports = __webpack_public_path__ + "static/media/iron_plate_boots.cced8e70.png";